import {Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterSegments } from 'src/app/models/router-segments';
import { Permissions } from '../../models/principal/permission';
import { TenantService } from 'src/app/services/api/tenant.service';
import { BreadcrumbItem } from '../../models/breadcrumb/breadcrumb-item';
import { translate } from '@jsverse/transloco';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {TenantList} from 'src/app/models/tenant/tenant';
import { combineLatest, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { CreateTenantComponent } from '../tenants-mgmt/create-tenant/create-tenant.component';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import {Constants} from 'src/app/models/constants';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { TenantOnboardingDetailsComponent } from './tenant-onboarding-details/tenant-onboarding-details.component';
import { ManagementTypes } from 'src/app/models/management-type';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { WorkflowDiagramComponent } from 'src/app/components/workflow-diagram/workflow-diagram.component';
import { MatDialog } from '@angular/material/dialog';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import cloneDeep from 'lodash/cloneDeep';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { EditTenantService } from 'src/app/services/api/edit-tenant.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';


const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_CREATE,
    action: Permissions.TENANT_CREATE
  },
  {
    key: PermissionKeys.TENANT_READ,
    action: Permissions.TENANT_READ
  },
  {
    key: PermissionKeys.TENANT_UPDATE,
    action: Permissions.TENANT_UPDATE
  }
];

@Component({
    selector: 'app-tenant-onboarding',
    templateUrl: './tenant-onboarding.component.html',
    styleUrls: ['./tenant-onboarding.component.scss'],
    standalone: false
})
export class TenantOnboardingComponent   implements OnInit {
private destroyRef = inject(DestroyRef);
  private http = inject(HttpClient);
  @Input() selectedItem: any;
  @ViewChild(MatSort, {static: true}) sort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  Constants = Constants;
  tenant: string;
  enterpriseClient: boolean;
  breadcrumbItems: BreadcrumbItem[];
  ManagementTypes = ManagementTypes;

  RouterSegments = RouterSegments;
  data: any;
  tenantData: any;
  tenantDataName: any;
  tenantId: string;

  displayedColumns: string[] = ['tenantId', 'region', 'target', 'creationFlow', 'menu'];
  dataSource: any;
  selectedMenuItem: any;
  dashboard: any;
  showSpinner: any;
  dropdownsList: any = [];
  dashboardLink: any;
  tenantLink: any;
  instancesCount = 0;
  type: any;
  region: any;
  status: any;
  cloud: any;
  filteredColumns: any;
  clearData: boolean;
  subscription: Subscription;
  isReader: boolean;
  Permissions = Permissions;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  isFailed = false;
  showPagination = true;
  pageIndex = 0;
  paginationSize = 10;
  regionList: any;
  statusList: any;
  dataWorkflow: any;
  workflowDetails: any;

  constructor(private route: ActivatedRoute,private router: Router, private authService: AuthService, private tenantService: TenantService,
    private sidenavService: SidenavService, private toastrService: CustomToastrService, public dateTimeFormatService: DateTimeFormatService,
    private instanceService: InstancesService, private permissionsService: PermissionsService,
    private toastrErrorService: ToastrErrorService, private dialog: MatDialog, private EditTenantService: EditTenantService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.TENANT_READ]) {
      this.router.navigate(['/', this.authService.principal.provider, 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.tenantId = this.route.snapshot.params.id;
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.TENANT_ONBOARDING_TENANT';
    const typeData = localStorage.getItem('filteredOnboardingType');
    if(typeData !== undefined){
      this.type = typeData;
    }
    const regionData = localStorage.getItem('filteredOnboardingRegion');
    if(regionData !== undefined){
      this.region = regionData;
    }
    const cloudData = localStorage.getItem('filteredOnboardingCloud');
    if(cloudData !== undefined){
      this.cloud = cloudData;
    }
    const statusData = localStorage.getItem('filteredOnboardingStatusTenant');
    if(statusData !== undefined){
      this.status = statusData;
    }
    this.dashboardLink = ({label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING')});
    this.tenantLink = ({label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING_TENANT'), url: ['tenant-onboarding']});

    const regionOptions = [
      {value: 'APAC' , selected: false},
      {value: 'APAC_2' , selected: false},
      {value: 'AUSTRALIA' , selected: false},
      {value: 'AUSTRALIA_2' , selected: false},
      {value: 'BRAZIL' , selected: false},
      {value: 'BRAZIL_2' , selected: false},
      {value: 'CANADA' , selected: false},
      {value: 'EUROPE' , selected: false},
      {value: 'FRANCE' , selected: false},
      {value: 'GERMANY' , selected: false},
      {value: 'INDIA' , selected: false},
      {value: 'JAPAN' , selected: false},
      {value: 'KOREA' , selected: false},
      {value: 'NORWAY' , selected: false},
      {value: 'SOUTH_AFRICA' , selected: false},
      {value: 'SWEDEN' , selected: false},
      {value: 'SWITZERLAND' , selected: false},
      {value: 'UK' , selected: false},
      {value: 'NORTH_AMERICA' , selected: false},
      {value: 'NORTH_AMERICA_2' , selected: false},
      {value: 'NORTH_AMERICA_3' , selected: false},
      {value: 'NORTH_AMERICA_4' , selected: false},
      {value: 'UAE' , selected: false}
    ];
    const cloudOptions = [ {value: 'AWS' , selected: false},
    {value: 'Azure' , selected: false}
   ];
    const statusOptions = [
      {value: 'Onboarded' , selected: false},
      {value: 'Onboarding' , selected: false},
      {value: 'Onboarding_failed' , selected: false},
      {value: 'removed' , selected: false}
    ];
    const typeOptions = [
      {value: ManagementTypes.EXTERNAL, label: translate('INSTANCE_LIST.EXTERNAL'), selected: false},
      {value: ManagementTypes.EXTERNAL_FOR_ACTION, label: translate('INSTANCE_LIST.EXTERNAL_FOR_ACTION'), selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Type',
        placeholder: 'Select Type',
        options: typeOptions
      },
      {
        title: 'Region',
        placeholder: 'Select Region',
        options: []
      },
      {
        title: 'Cloud',
        placeholder: 'Select Cloud',
        options: cloudOptions
      },
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: []
      }
    ];
    this.clearData = true;
    this.showSpinner = true;
    this.tenant = this.authService.principal.provider;
    this.breadcrumbs();
    this.regionList = [...new Set(regionOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.regionList.forEach((value) => {
      this.dropdownsList[1].options.push({value, selected: false});
    });
    this.statusList = [...new Set(statusOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.statusList.forEach((value) => {
      this.dropdownsList[3].options.push({value, selected: false});
    });
    // this.type = ManagementTypes.EXTERNAL;
    this.tenantService.getTenants(undefined, this.type, this.region ? this.region : undefined,
    this.cloud ? this.cloud : undefined,
              this.status ? this.status : undefined)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.showSpinner = false;
          this.data = data;
          this.loadData(this.data);
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        this.showSpinner = false;
        this.isFailed = true;
      });

    this.instanceService.getInstances()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.instancesCount = data.total;
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event?.pageIndex;
      this.paginationSize = event?.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.data.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

  loadData(data?): void {
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortData(event): void {
    this.sort = event;
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.data = this.sortInstanceData(event);
    this.dataSource = new MatTableDataSource(this.data?.slice(this.pageIndex, this.paginationSize));
  }

  sortInstanceData(event): any {
    return this.data?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'tenantId':
          comparatorResult = a?.tenantId && b?.tenantId ? a?.tenantId?.localeCompare(b?.tenantId) : !a?.tenantId ? -1 : 1;
          break;
        case 'region':
          comparatorResult = a?.tenantId && b?.tenantId ? a?.tenantId?.localeCompare(b?.tenantId) : !a?.tenantId ? -1 : 1;
          break;
        case 'target':
          comparatorResult = a?.tenantId && b?.tenantId ? a?.tenantId?.localeCompare(b?.tenantId) : !a?.tenantId ? -1 : 1;
          break;
        case 'dateCreated':
          comparatorResult = a?.dateCreated && b?.dateCreated ? new Date(a?.dateCreated)?.getTime() - new Date(b?.dateCreated)?.getTime()
            : !a?.dateCreated ? -1 : 1;
          break;
        default:
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) : !a?.name ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  gotoSection(menuItem: any): void {
    this.selectedMenuItem = menuItem;
  }

  createTenant(): void{
    this.EditTenantService.setData("");
    this.EditTenantService.setIsEdit(false);
    this.router.navigate(['/',this.authService.principal.provider,RouterSegments.TENANT_ONBOARDING,'create']);
  }

  breadcrumbs(): void {
    this.breadcrumbItems = [];
      this.breadcrumbItems.push({icon: 'home'}, {label: this.dashboardLink.label, url:[]}, {label: this.tenantLink.label,
        url: this.tenantLink.url});
  }

  tenantDetails(tenant): any {
    const instanceObj = {
      tenantId: tenant.tenantId,
      pageSize: this.instancesCount
    };
    this.tenantService.getTenantAccountDetails(tenant.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data) {
          this.tenantData = data;
          this.tenantService.getTenantClientDetails(tenant.tenantId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data1) => {
            if(data1) {
              this.tenantDataName = data1;
            }
          });
          this.getInstancesForPopup(instanceObj, tenant);
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        this.getInstancesForPopup(instanceObj, tenant);
      });
  }

  getInstancesForPopup(instanceObj, tenant): void {
    this.instanceService.getInstances(instanceObj)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((instances) => {
      if (instances) {
        return this.sidenavService.openInRightSidenav(TenantOnboardingDetailsComponent,
          {accountData: this.tenantData, tenantData: tenant, instancesData: instances.data, tenantDataName: this.tenantDataName,
             instanceCount: instances.total});
      }
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.sidenavService.openInRightSidenav(TenantOnboardingDetailsComponent, {accountData: this.tenantData, tenantData: tenant});
    });
  }

  selectionChanged(): void {
    this.showSpinner = true;
    this.data = [];
    this.loadData(this.data);
    this.tenantService.getTenants(undefined, this.dropdownsList[0].selectedValue, this.dropdownsList[1].selectedValue,
      this.dropdownsList[2].selectedValue, this.dropdownsList[3].selectedValue)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.showSpinner = false;
          this.data = data;
          this.loadData(this.data);
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  closeMenu(data): void {
      this.sidenavService.searchFilter.next(data);
      this.filteredColumnsFunction(data);
  }

  filterColumns(): void {
    if(this.type) {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
        if (item.value === this.type) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.region) {
      this.dropdownsList[1].options.filter((item) => {
        if (item.value === this.region) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[1].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.cloud) {
      this.dropdownsList[2].options.filter((item) => {
        if (item.value === this.cloud) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[2].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.status) {
      this.dropdownsList[3].options.filter((item) => {
        if (item.value === this.status) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[3].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('INSTANCE_STATUS.TENANT'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      type: this.dropdownsList[0].options,
      region: this.dropdownsList[1].options,
      cloud: this.dropdownsList[2].options,
      status: this.dropdownsList[3].options,
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          if (filteredColumns) {
            this.clearData = true;
            this.tenant = undefined;
            if(filteredColumns[0] !== '') {
              this.type = filteredColumns[0];
            }
            if(filteredColumns[1] !== '') {
              this.region = filteredColumns[1];
            }
            if(filteredColumns[2] !== '') {
              this.cloud = filteredColumns[2];
            }
            if(filteredColumns[3] !== '') {
              this.status = filteredColumns[3];
            }
            this.getTenantsData();
          }
        });
  }

  filteredColumnsFunction(data): void {
    if(this.type === data) {
      this.type = undefined;
    }else if(this.region === data) {
      this.region = undefined;
    }else if(this.cloud === data) {
      this.cloud = undefined;
    } else if(this.status === data) {
      this.status = undefined;
    }
    this.getTenantsData();
  }

  getTenantsData(): void {
    this.showSpinner = true;
    this.isFailed = false;
    this.data = [];
    this.loadData(this.data);
    if(this.type) {
      localStorage.setItem('filteredOnboardingType', this.type);
      } else {
        localStorage.removeItem('filteredOnboardingType');
      }
    if(this.region) {
      localStorage.setItem('filteredOnboardingRegion', this.region);
      } else {
        localStorage.removeItem('filteredOnboardingRegion');
      }
      if(this.cloud) {
        localStorage.setItem('filteredOnboardingCloud', this.cloud);
        } else {
          localStorage.removeItem('filteredOnboardingCloud');
        }
        if(this.status) {
          localStorage.setItem('filteredOnboardingStatusTenant', this.status);
          } else {
            localStorage.removeItem('filteredOnboardingStatusTenant');
          }
    this.tenantService.getTenants(undefined, this.type ? this.type : undefined, this.region ? this.region : undefined,
    this.cloud ? this.cloud : undefined,
              this.status ? this.status : undefined).pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data1 => {
                if (data1) {
                  this.showSpinner = false;
                  this.data = data1;
                  this.loadData(this.data);
                }
              },
              (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
                this.showSpinner = false;
                this.isFailed = true;
              });
  }

  openWorkflowDiagram(data): void {
    this.dialog.open(WorkflowDiagramComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '1100px',
      autoFocus: false,
      data: {
        selectedTenant: data
      }
    });
  }

  resetFilter(): void {
    this.type = undefined;
    this.region = undefined;
    this.cloud = undefined;
    this.status = undefined;
    this.clearData = false;
    this.sidenavService.searchFilter.next('data');
    this.resetAllValues();
    this.getTenantsData();
  }

  resetAllValues(): void {
    this.dropdownsList.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
  }

  editTenant(data): void {
       const editData = cloneDeep(data);
       this.EditTenantService.setData(data);
       this.EditTenantService.setIsEdit(true);

    this.router.navigate(['/',this.authService.principal.provider,RouterSegments.TENANT_ONBOARDING,'create']);



  }

  async downloadWithResetIds(): Promise<void> {
    const template = await firstValueFrom(this.http.get<any>('assets/keycloak/saas-customer-template-realm-kc.json'));
    const resetData = this.resetIds(template);
    this.download(resetData, 'saas-customer-template-realm-kc.json');
  }

  // Walks the whole structure, so nested ids are reset too
  private resetIds(node: any): any {
    if (Array.isArray(node)) {
      return node.map(item => this.resetIds(item));
    }
    if (node && typeof node === 'object') {
      const result: any = {};
      for (const [key, value] of Object.entries(node)) {
        result[key] = key === 'id' ? crypto.randomUUID() : this.resetIds(value);
      }
      return result;
    }
    return node;
  }

  private download(data: unknown, fileName: string): void {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

}

